import { PocSwitch } from 'commons/components/components-wrapper/poc-switch.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import {
    FormSection,
    FormSectionTitle,
    OptionalHint,
    OptionalRow,
    OptionalSettingsOption,
} from 'modules/settings/components/custom-notifications/custom-notification-form.style';

export interface CustomNotificationOptionalSettingsTranslationKeys {
    title: string;
    resetTitle: string;
    resetHint: string;
    commentTitle: string;
    commentHint: string;
}

export interface CustomNotificationOptionalSettingsSectionProps {
    isResettable: boolean;
    requiresCommentOnReset: boolean;
    translationKeys: CustomNotificationOptionalSettingsTranslationKeys;
    onResettableChange: (value: boolean) => void;
    onRequiresCommentOnResetChange: (value: boolean) => void;
}

export const CustomNotificationOptionalSettingsSection: React.FC<CustomNotificationOptionalSettingsSectionProps> = ({
    isResettable,
    requiresCommentOnReset,
    translationKeys,
    onResettableChange,
    onRequiresCommentOnResetChange,
}) => {
    const { t } = useTranslation();

    return (
        <FormSection>
            <FormSectionTitle variant="subtitle2">{t(translationKeys.title)}</FormSectionTitle>

            <OptionalRow>
                <OptionalSettingsOption>
                    <PocTypography variant="body1">{t(translationKeys.resetTitle)}</PocTypography>
                    <OptionalHint variant="body2">{t(translationKeys.resetHint)}</OptionalHint>
                </OptionalSettingsOption>
                <PocSwitch
                    aria-label={t(translationKeys.resetTitle)}
                    checked={isResettable}
                    controlled
                    onValueChange={(ev) => onResettableChange(ev.detail)}
                />
            </OptionalRow>

            <OptionalRow>
                <OptionalSettingsOption>
                    <PocTypography variant="body1">{t(translationKeys.commentTitle)}</PocTypography>
                    <OptionalHint variant="body2">{t(translationKeys.commentHint)}</OptionalHint>
                </OptionalSettingsOption>
                <PocSwitch
                    aria-label={t(translationKeys.commentTitle)}
                    checked={requiresCommentOnReset}
                    controlled
                    disabled={!isResettable}
                    onValueChange={(ev) => onRequiresCommentOnResetChange(ev.detail)}
                />
            </OptionalRow>
        </FormSection>
    );
};
